module.exports = __webpack_public_path__ + "static/media/index-gift-dialog-top.ec45ea6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/index-gift-dialog-top.png
// module id = 1923
// module chunks = 6